import { useEffect, useState } from "react";
import { IInStore, IProdDef } from "../../interfaces/IProducts";
import ProdType from "./ProdType";
import ProdPrice from "./ProdPrice";
import ProdTerm from "./ProdTerm";
import ProdDetail from "./ProdDetail";
import ToCartButton from "../cart/ToCartButton";
import ProdDuration from "./ProdDuration";

/*-----------------------
 * jeżeli showModalId = props.inStore?.productId - wówczas wyświetlam showModal
 * hideActionButton? = true -> ukryj przyciski Do koszyka / Wyślij zapytanie
 *----------------------- */
const ProdDetailModal = (props: { inStore?: IInStore; prodDef?: IProdDef; showModalId?: number; hideActionButton?: boolean }) => {
    const [activateModal, setActivateModal] = useState("");
    useEffect(() => {
        if (props.showModalId && Math.abs(props.showModalId) === props.inStore?.productId) {
            setActivateModal(activateModal === "is-active" ? "" : "is-active");
        }
    }, [props.showModalId]);

    let hideActionButton = false;
    if (props.hideActionButton) {
        hideActionButton = props.hideActionButton;
    }
    // console.log(hideActionButton);
    return (
        <>
            <div className={`modal ${activateModal}`}>
                <div className="modal-background"></div>
                <div className="modal-card">
                    <div className="modal-card-head ">
                        <div className="modal-card-title">
                            <ProdType
                                className="is-size-6 mt-3 has-text-weight-semibold"
                                prodType={props.inStore?.prodType}
                                courseType={props.inStore?.courseType}
                            />

                            <div className="pt-1 modal_title_width"> {props.prodDef?.name ? props.prodDef?.name : props.inStore?.pName}</div>
                        </div>
                        <div className="modal_delete_button">
                            <button className="delete" aria-label="close" onClick={() => setActivateModal("")}></button>
                        </div>
                    </div>

                    <section className="modal-card-body">
                        <ProdDetail inStore={props.inStore} getProductId={props.showModalId} />
                        <div className="is-size-7 ">identyfikator produktu: {props.inStore?.productId}</div>
                    </section>

                    <footer className="modal-card-foot">
                        <div className="list has-visible-pointer-controls">
                            <div className="list-item">
                                <div className="list-item-content">
                                    <ProdTerm inStore={props.inStore} />
                                    <ProdDuration inStore={props.inStore} showLabel={true} size={"XXS"} />
                                </div>

                                <div className="list-item-content">
                                    <div className="pl-4">
                                        <ProdPrice inStore={props.inStore} />
                                    </div>
                                </div>

                                <div className="list-item-controls">
                                    <div className="buttons is-right">
                                        {!hideActionButton && (
                                            <ToCartButton className="ml-2" inStore={props.inStore} key={props.inStore?.productId} />
                                        )}

                                        <button className="button mx-1" onClick={() => setActivateModal("")}>
                                            Zamknij okno
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* <div className="">
                                <ProdPrice inStore={props.inStore} />
                            </div> */}

                            {/* <div className="list-item-controls">
                                <div className="buttons is-right">
                                    {!hideActionButton && <ToCartButton className="ml-2" inStore={props.inStore} key={props.inStore?.productId} />}

                                    <button className="button mx-1" onClick={() => setActivateModal("")}>
                                        Zamknij okno
                                    </button>
                                </div>
                            </div> */}
                        </div>
                    </footer>
                    <div className="is-size-7 has-text-light">prod_id: {props.inStore?.productId}</div>
                </div>
            </div>
        </>
    );
};

export default ProdDetailModal;
